export function migrateGameEventHistory(gameEventHistory) {
    return gameEventHistory;
}
